
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNotificationSettings } from "@/hooks/admin/settings/useNotificationSettings";
import { NotificationItem } from "./notification-settings/NotificationItem";

const NotificationSettings = () => {
  const {
    settings,
    loading,
    saving,
    handleToggleEmail,
    handleToggleInApp,
    handleFrequencyChange,
    saveSettings,
  } = useNotificationSettings();

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-gray-900 dark:text-gray-100">Notification Settings</CardTitle>
          <CardDescription>Configure which events trigger notifications</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center py-8">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-nation-blue border-t-transparent"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-gray-900 dark:text-gray-100">Notification Settings</CardTitle>
        <CardDescription>Configure which events trigger notifications and how they are delivered</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {settings.map((setting, index) => (
            <NotificationItem
              key={setting.key}
              setting={setting}
              onToggleEmail={() => handleToggleEmail(index)}
              onToggleInApp={() => handleToggleInApp(index)}
              onFrequencyChange={(value) => handleFrequencyChange(index, value)}
            />
          ))}
          
          <div className="flex justify-end">
            <Button 
              onClick={saveSettings} 
              disabled={saving}
              className="bg-nation-blue hover:bg-nation-blue/90 text-white border-0"
            >
              {saving ? 'Saving...' : 'Save Settings'}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationSettings;
